<script lang="ts" setup>
const props = defineProps<{
  isRsvpDisabled: boolean;
}>();

const {
  formRef,
  loading,
  selectedRsvpActivity,
  state,
  isAlreadyConfirmed,
  eventRsvpActivityItems,
  renderedFormFields,
  chooseAttending,
  chooseNotAttending,
  onSelectedRsvpChange,
  editAttendance,
  submit,
} = useRsvpActivityForm();

async function onSubmit() {
  await submit();
}

async function onEditAttendance() {
  await editAttendance();
}
function onChooseAttending() {
  chooseAttending();
}

function onChooseNotAttending() {
  chooseNotAttending();
}
</script>

<template>
  <div class="flex flex-col w-full mx-auto gap-8 max-w-sm sm:max-w-[357px] md:gap-10">
    <template
      v-if="isRsvpDisabled && !isAlreadyConfirmed"
    >
      <UAlert
        variant="subtle"
        class="text-sm xs:text-base xl:text-lg text-center text-primary-800 max-w-[calc(100%-2rem)] mx-auto md:max-w-none"
        title="RSVP Ditutup"
        description="Maaf, batas waktu konfirmasi telah lewat. Anda tidak dapat membuat atau mengubah konfirmasi RSVP."
        :ui="{ title: 'font-medium' }"
      />
    </template>

    <!-- Content when already confirmed -->
    <template
      v-else-if="!isAlreadyConfirmed"
    >
      <div class="flex items-center justify-center gap-4">
        <UButton
          label="HADIR"
          variant="soft"
          class="rounded-full"
          :data-active="state.status === 'attending'"
          :disabled="loading.state || props.isRsvpDisabled"
          @click="onChooseAttending"
        />

        <UButton
          label="TIDAK HADIR"
          variant="soft"
          class="rounded-full"
          :data-active="state.status === 'not-attending'"
          :disabled="loading.state || props.isRsvpDisabled"
          @click="onChooseNotAttending"
        />
      </div>

      <!-- Section for attending the event -->
      <div
        v-if="state.status === 'attending'"
        data-aos="fade"
        data-aos-delay="50"
        class="flex flex-col gap-6"
      >
        <p
          class="text-sm xs:text-base xl:text-lg"
        >
          Pilih acara yang akan dihadiri
        </p>

        <!-- List of RSVP Activities -->
        <PRsvpListActivity
          v-model:selected-rsvp-activity="selectedRsvpActivity"
          :event-rsvp-activity-items="eventRsvpActivityItems"
          @on-selected-rsvp-change="onSelectedRsvpChange"
        />

        <!-- Form for selected RSVP Activity -->
        <PRsvpForm
          v-if="selectedRsvpActivity"
          ref="formRef"
          v-model="state"
          :is-loading="loading.state"
          :rendered-form-fields="renderedFormFields"
          :is-rsvp-disabled="props.isRsvpDisabled"
          @submit="onSubmit"
        />
      </div>

      <!-- Section for not attending the event -->
      <div
        v-if="state.status === 'not-attending'"
        class="flex flex-col gap-6 items-center"
        data-aos="fade"
        data-aos-delay="50"
      >
        <p class="text-sm xs:text-base xl:text-lg">
          Apakah Anda yakin?
        </p>

        <UButton
          label="Konfirmasi Ketidakhadiran"
          class="rounded-full w-fit"
          variant="soft"
          block
          :loading="loading.state"
          @click="onSubmit"
        />
      </div>
    </template>

    <template v-else>
      <LazyPRsvpConfirmed
        :is-rsvp-disabled="props.isRsvpDisabled"
        @edit-attendance="onEditAttendance"
      />
    </template>
  </div>
</template>
